<template>
<div>
  <span class="sr-only" aria-live="polite">{{ alertText }}</span>

  <div id="activity_instructions" class="text-white p-4">{{ $t('To move each pattern, either drag and drop the box to a new position, or tab to a box and use the up or down arrow keys to change position.') }}</div>

  <div class="vrank flex flex-wrap items-center justify-center">
    <div class="sort-wrapper flex flex-wrap w-3/12 md:w-2/12 mb-3 text-center pr-2">
      <span class="flex-wrap w-full font-bold text-sm text-right pr-2">{{ $t('More Like Me') }}</span>

      <ul class="w-1/5 flex flex-col text-center">
        <li v-for="(choice, index) in itemsarray" class="flex mb-2 h-12 justify-center items-center font-bold text-xl">
            {{ index + 1 }}
        </li>
      </ul>

      <draggable :list="itemsarray"
        animation="600"
        tag="ul"
        class="w-4/5 flex flex-col"
        role="listbox"
        :move="onMove"
      >
        <li v-for="(choice, index) in itemsarray"
          :id="choice.column"
          class="columnfill h-12 flex mb-2 overflow-hidden justify-center items-center rounded shadow w-full cursor-move text-sm"
          :key="choice.id"
          :ref="'sidebar_' + index"
          role="option"
          draggable="true"
          tabindex="1"
          @keyup.arrow-up="arrowUp('sidebar', choice, index)"
          @keyup.arrow-down="arrowDown('sidebar', choice, index)"
        >
            <h2 class="label relative text-base py-0">
              {{ choice.attributes['title'].text }}
            </h2>
        </li>
      </draggable>

      <span class="flex-wrap w-full font-bold text-sm text-right pr-2 -mt-2">{{ $t('Less Like Me') }}</span>
        <div class="mt-3 inline-block m-auto" v-if="demo !== ('1')">
          <button id="submitResults" @click="putResults" type="submit" class="submitResults px-5 py-2">{{ $t('Next') }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>

        <div class="mt-3 inline-block m-auto"  v-else>
          <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">{{ $t('Restart Demo') }}<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
    </div>
    
    <div class="vrank-wrapper w-9/12 md:w-8/12 py-3">
      <draggable :list="itemsarray"
        animation="600"
        tag="ul"
        class="vrank-responsive"
        handle=".handle"
        role="listbox"
        :move="onMove"
      >
        <li v-for="(choice, index) in itemsarray"
          :id="choice.column"
          class="vrank-item"
          :key="choice.id"
          :ref="'main_' + index"
          role="option"
          draggable="true"
          tabindex="1"
          @keyup.arrow-up="arrowUp('main', choice, index)"
          @keyup.arrow-down="arrowDown('main', choice, index)"
        >
          <div class="handle"></div>
          <!-- <div class="flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
          <div class="flex-grow align-middle">
            <div class="attributes flex flex-col">
                    <h2 class="label relative">
                      {{ choice.attributes['title'].text }}
                    </h2>

                    <div class="description">
                      <img v-if="choice.attributes.image" :src="choice.attributes.image.text" :alt="choice.attributes.title.text" class="image float-right"/>
                      <span v-html="brToLi(choice.attributes['description'].text)"></span>
                      <button
                        v-if="choice.attributes['showmore']"
                        class="showmore"
                        @click="showModal(index)"
                      > 
                        <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                      </button>
                      <card-modal :ref="'modal_' + index" v-if="choice.attributes['showmore']">
                        <span v-html="choice.attributes['showmore'].text"></span>
                      </card-modal>
                    </div>
            </div>
          </div>
        </li>
      </draggable>
    </div>
  </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'
import brToLi from '../../mixins/br-to-li.js'

export default {
  display: "Simple",
  order: 1,
  mixins: [brToLi],
  components: {
    draggable,
  },
  props: {
      array: '',
      route:'',
      demo:'',
  },
  data() {
    return {
      itemsarray: this.getItemsWithColumns(),
      alertText: '',
    }
  },
  methods: {
    showModal(index) {
      let modal_id = "modal_" + index;
      this.$refs[modal_id][0].show(index);
    },
    restartActivity() {
      $( ".submitResults").addClass( "loading" );
      location.reload();
    },
    getItemsWithColumns() {
      return this.array.map((item, index) => {
        item.column = 'column_' + (index + 1);
        return item;
      });
    },
    putResults: function (event) {
      $( "#submitResults").addClass( "loading" );
      axios.put(this.route, {
        results: this.itemsarray.map(dataSet => dataSet.id)
      }).then(function (response) {
          console.log(response);
        }).then(function (event) {
          location.reload();
        })
    },
    arrowUp(section, choice, index) {
      if (index > 0) {
        let newIndex = index - 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    arrowDown(section, choice, index) {
      if (index < this.itemsarray.length - 1) {
        let newIndex = index + 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    updateAlertText(title, newIndex) {
      this.alertText = title + ', ranked ' + (newIndex + 1) + ' of ' + (this.itemsarray.length);
    },
    moveItem(fromIndex, toIndex) {
      let element = this.itemsarray[fromIndex];
      this.itemsarray.splice(fromIndex, 1);
      this.itemsarray.splice(toIndex, 0, element);
    },
    focusItem(prefix, index) {
      this.$nextTick(() => {
        let el = this.$refs[prefix + '_' + index];

        if (el && el[0]) {
          el[0].focus();
        }
      })
    },
    onMove(move) {
      if (move.draggedContext) {
        let title = move.draggedContext.element.attributes.title.text;
        let newIndex = move.draggedContext.futureIndex;
        this.updateAlertText(title, newIndex)
      }
    },
  },
};
</script>
